// extracted by mini-css-extract-plugin
module.exports = {"input":"PromoCodeInput_input__D1Vkd","disabled":"PromoCodeInput_disabled__hgQxG"};